import "./polyfills";
import { initTabsStore } from "assets/tabs";
import "./layout-effects";
import "./video-player";
import { initTabsStore } from "assets/tabs";
import utils from "./utils";
import { initCSSAutoPrefixer } from "assets/css-autoprefixer";
import { initScrollProgress } from "assets/scroll-progress";
import { initSearch } from "assets/search";
import { initTextarea } from "assets/textarea";
import { initAccessibility } from "./accessibility";
import { initCart } from "./cart";
import { type EditorStore } from "./editor";
import { initMediaGallery } from "./media-gallery";
import { initModals } from "./modals";
import { initPageTransitions } from "./page-transitions";
import { initPagination } from "./pagination";
import { initProductData } from "./product-data";

import { initQuickView } from "./quick-view";
import { initScrollBar } from "./scrollbar";
import { initSmoothScroll } from "./smooth-scroll";
import { initToast } from "./toast";
import { initTooltip } from "./tooltip";

// @ts-ignore
window.utils = utils;

document.dispatchEvent(new CustomEvent("theme:utils:loaded"));

(() => {
  window.onerror = function (...args) {
    /* TODO: This is potentially blocking valuable information about other errors.*/
    return args?.[0] === "Script error.";
  };

  window.onunhandledrejection = function (event) {
    console.warn("🚨 Unhandled Promise Rejection:", event.reason);
  };

  const origConsoleWarn = console.warn;
  window.console.warn = function (...args) {
    if (args?.[0]?.includes("Alpine Expression Error")) {
      const [message, ...rest] = args;
      console.error(
        `%cAlpine JS Error:%c \n\n${message?.replaceAll("\n\n", "\n")}\n`,
        "color: red; font-size: 17px; font-weight: 600;",
        "font-weight: 600; font-size: 14px;",
        ...rest
      );
      return;
    }
    return origConsoleWarn.apply(this, args);
  };
})();

export const initTheme = () => {
  window.Alpine.store("editor", {
    load_section_id: "",
    unload_section_id: "",
    select_section_id: "",
    reorder_section_id: "",
    select_block_id: "",
    inspector: false,
    setValue(key: keyof typeof this, value: string | boolean) {
      this[key] = value;
    },
  });
  const editor = window.Alpine.store("editor") as EditorStore;
  window.Alpine.magic("editor", () => editor);

  initTabsStore();
  initModals();
  initAccessibility();
  initQuickView();
  initCart();
  initProductData();
  initScrollBar();
  initTextarea();
  initTooltip();
  initToast();
  initSearch();
  initMediaGallery();
  initSmoothScroll();
  initPageTransitions();
  initPagination();
  initScrollProgress();
  initCSSAutoPrefixer();

  if (window.design_mode) {
    document.dispatchEvent(new CustomEvent("theme:editor:init"));
  }
  document.dispatchEvent(new CustomEvent("theme:init"));
};

document.addEventListener("alpine:init", initTheme);
